import {
  ServerResponseBudgetHistory,
  BudgetHistory,
} from 'models/BudgetHistory';

export default function getBudgetHistory(budget: ServerResponseBudgetHistory) {
  const budgetHistory: BudgetHistory = {
    Actual: 0,
    Budget: 0,
    Expenses: [],
    Percentage: 0,
    FiscalYear: 0,
  };

  const lastFiscalYearBudget = budget.Expenses[0];

  if (!lastFiscalYearBudget) return budgetHistory;

  budgetHistory.Actual = lastFiscalYearBudget.Actual;
  budgetHistory.Budget = lastFiscalYearBudget.Budget;
  budgetHistory.Expenses = budget.Expenses.map((expense) => ({
    Actual: expense.Actual,
    Budget: expense.Budget,
    FiscalYear: expense.FiscalYear,
    Percentage: expense.Percentage,
  }));
  budgetHistory.Percentage = lastFiscalYearBudget.Percentage;
  budgetHistory.FiscalYear = lastFiscalYearBudget.FiscalYear;

  return budgetHistory;
}
